import Vue from 'vue'
import Component from 'vue-class-component'
import DataSnapshot = firebase.database.DataSnapshot;
import User from "@/lib/models/User";

@Component
export default class GoogleSignIn extends Vue {
    private $firebase: any;


    signInUsingGoogle() {
        const provider = new this.$firebase.auth.GoogleAuthProvider();
        return this.$firebase.auth().signInWithPopup(provider).then((result: any) => {

            const user = result.user;
            return this.$firebase.database().ref('/users/' + user.uid).once('value').then((snapshot: DataSnapshot) => {
                if (snapshot.val() === null) {
                    return this.$firebase.database().ref('users/' + user.uid).set((new User()).fromObject({
                        uid: user.uid,
                        name: user.displayName,
                        email: user.email,
                        signInProvider: 'google',
                        verified: false
                    })).then(() => {
                        return {status: "success", message: "Logged in successfully.", user: user};
                    }, (err: { message: string }) => {
                        console.log(err.message);
                        return {status: "success", message: "Logged in successfully.", user: user};
                    });
                } else {
                    return {status: "success", message: "Logged in successfully.", user: user};
                }
            });

        }).catch((err: { message: string }) => {
            console.log(err);
            return {status: "error", message: err.message};
        });
    }
}
